import style from './Leaderboards.module.css';
import NumberFormatter from "../libs/NumberFormatter";

export default function Leaderboards(props: {show: boolean, scores: {username: string, score: number}[]}) {

    return (
        <>
        {
            props.show &&
            <div className="absolute inset-0 flex justify-center items-center z-10 bg-black/50">
                    <div className="px-6 py-6 bg-white border w-80 max-h-96">
                        <h2 className={`text-2xl ${style.mainTitle}`}>Today's Best Investors</h2>
                        <table className="w-full h-full overflow-y-scroll no-scrollbar">
                            <thead className="text-left">
                                <tr>
                                    <th className="pr-2 py-2">Investor</th>
                                    <th className="px-2 py-2 text-right">MKTVALUE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.scores.map((score, index) =>
                                        <tr key={index}>
                                            <td className="font-bold pr-2 py-2">@{score.username}</td>
                                            <td className="px-2 py-2 text-right">{NumberFormatter.toCurrency(score.score)}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
            </div>
        }
        </>
    );

}